import React from 'react';
import c from 'classnames';

import { SearchFacets } from '@uncinc/react-searchkit';
import type { SearchFacetsProps } from '@uncinc/react-searchkit/dist/components/Facets';

const SearchPromotedContentThemesFacets: React.FC<SearchFacetsProps> = (props) => {
  const {
    className,
    children,
    ...restProps
  } = props;

  const classNames = c('SearchPromotedContentThemes__Facets', className);

  return (
    <SearchFacets {...restProps} className={classNames}>
      {children}
    </SearchFacets>
  );
};

export default SearchPromotedContentThemesFacets;
